import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const standaloneCss = ".oab-screen{width:100%;min-height:100vh;display:flex;align-items:center;justify-content:center}.oab-screen>.oab-spinner{width:32px;height:32px}oab-fe{width:100%}";

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const AssetServerSubdomainsMap = {
    dev: 'dev.',
    test: 'test.',
    int: 'int.',
    pprod: 'preprod.',
    prod: '',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};
const StandaloneComponent = /*@__PURE__*/ proxyCustomElement(class StandaloneComponent extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.isLoading = true;
        this.manifest = undefined;
        this.user = undefined;
        this.consents = [];
        this.country = undefined;
        this.language = undefined;
        this.direction = undefined;
        this.token = undefined;
        this.dealer = undefined;
        this.decline = undefined;
        this.offerId = undefined;
        this.section = undefined;
        this.dealerId = undefined;
        this.vehicleId = undefined;
        this.sourceUrl = undefined;
        this.serviceNotes = undefined;
        this.registrationId = undefined;
        this.serviceProduct = undefined;
        this.preferredDealerId = undefined;
        this.source = undefined;
        this.medium = undefined;
        this.campaign = undefined;
        this.term = undefined;
        this.content = undefined;
        this.bookingId = undefined;
        this.reservationId = undefined;
        this.dealerGroup = undefined;
        this.context = undefined;
        this.locale = undefined;
        this.login = undefined;
        this.track = undefined;
        this.env = 'int';
        this.build = 'prod';
    }
    mountOab() {
        var _a;
        const jsUrl = `${this.getOabBaseUrl()}${(_a = this.manifest) === null || _a === void 0 ? void 0 : _a.version}/index.es.js`;
        const script = document.createElement('script');
        script.onload = () => {
            this.isLoading = false;
        };
        script.src = jsUrl;
        script.type = 'module';
        document.head.appendChild(script);
    }
    getOabBaseUrl() {
        const build = this.build && this.build.toLocaleLowerCase() in AssetServerSubdomainsMap
            ? this.build.toLocaleLowerCase()
            : 'prod';
        return `https://${AssetServerSubdomainsMap[build]}assets.oneweb.mercedes-benz.com/plugin/oab-fe/`;
    }
    getOabManifestUrl() {
        return `${this.getOabBaseUrl()}oab-manifest.json`;
    }
    fetchManifest() {
        return __awaiter(this, void 0, void 0, function* () {
            const ck = new Date().getTime();
            return fetch(`${this.getOabManifestUrl()}?ck=${ck}`)
                .then((response) => response.json())
                .then((manifest) => manifest);
        });
    }
    componentWillLoad() {
        return __awaiter(this, void 0, void 0, function* () {
            this.env = this.env.toLowerCase();
            this.manifest = yield this.fetchManifest();
            this.mountOab();
        });
    }
    componentDidLoad() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.dsdbookHandleTrackingEvent = (data) => { var _a; return (_a = this.track) === null || _a === void 0 ? void 0 : _a.call(this, data); };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.dsdbookHandleLogin = this.login;
    }
    forceUpdateOabFeProps() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const oabFeElement = document.querySelector('oab-fe');
        if (!oabFeElement && (oabFeElement === null || oabFeElement === void 0 ? void 0 : oabFeElement.connectedCallback)) {
            window.clearTimeout(this.iProps);
            this.iProps = window.setTimeout(() => {
                this.forceUpdateOabFeProps();
            }, 0);
            return;
        }
        const dateTime = new Date().getTime().toString();
        oabFeElement[`render${dateTime}`] = 'done';
        if (this.consents && this.consents.length > 0) {
            oabFeElement['consents'] = this.consents;
            oabFeElement.setAttribute('consents', JSON.stringify(this.consents));
        }
        if (this.user && !isEmptyObject(this.user)) {
            oabFeElement['user'] = this.user;
            oabFeElement.setAttribute('user', JSON.stringify(this.user));
        }
        (_a = oabFeElement.connectedCallback) === null || _a === void 0 ? void 0 : _a.call(oabFeElement);
    }
    componentDidRender() {
        this.forceUpdateOabFeProps();
    }
    render() {
        // print props
        // console.log('dsdBook env ', this.env);
        // console.log('dsdBook locale ', this.locale);
        // console.log('dsdBook country ', this.country);
        // console.log('dsdBook language ', this.language);
        // console.log('dsdBook direction ', this.direction);
        // console.log('dsdBook context ', this.context);
        // console.log('dsdBook user ', this.user);
        // console.log('dsdBook consents ', this.consents);
        // console.log('dsdBook track ', this.track);
        // console.log('dsdBook login ', this.login);
        return (h(Host, null, h("div", { class: "oab-screen" }, this.isLoading && h("wb-spinner", { theme: "light", class: "oab-spinner" }), h("oab-fe", { style: { width: this.isLoading ? 0 : '100%' }, env: this.env, term: this.term, token: this.token, source: this.source, medium: this.medium, locale: this.locale, dir: this.direction, dealer: this.dealer, content: this.content, country: this.country, decline: this.decline, section: this.section, context: this.context, "offer-id": this.offerId, language: this.language, "dealer-id": this.dealerId, "external-url": this.sourceUrl, "booking-id": this.bookingId, "vehicle-id": this.vehicleId, "dealer-group": this.dealerGroup, "handle-login": "dsdbookHandleLogin", "service-notes": this.serviceNotes, reservationId: this.reservationId, "registration-id": this.registrationId, "service-product": this.serviceProduct, "preferred-dealer-id": this.preferredDealerId, "handle-tracking-event": "dsdbookHandleTrackingEvent" }))));
    }
    static get style() { return standaloneCss; }
}, [0, "oab-standalone", {
        "user": [8],
        "consents": [16],
        "country": [1],
        "language": [1],
        "direction": [1, "dir"],
        "token": [1],
        "dealer": [1],
        "decline": [1],
        "offerId": [1, "offer-id"],
        "section": [1],
        "dealerId": [1, "dealer-id"],
        "vehicleId": [1, "vehicle-id"],
        "sourceUrl": [1, "source-url"],
        "serviceNotes": [1, "service-notes"],
        "registrationId": [1, "registration-id"],
        "serviceProduct": [1, "service-product"],
        "preferredDealerId": [1, "preferred-dealer-id"],
        "source": [1],
        "medium": [1],
        "campaign": [1],
        "term": [1],
        "content": [1],
        "bookingId": [1, "booking-id"],
        "reservationId": [1, "reservation-id"],
        "dealerGroup": [1, "dealer-group"],
        "context": [1],
        "locale": [1],
        "login": [16],
        "track": [16],
        "env": [1537],
        "build": [1],
        "isLoading": [32],
        "manifest": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["oab-standalone"];
    components.forEach(tagName => { switch (tagName) {
        case "oab-standalone":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, StandaloneComponent);
            }
            break;
    } });
}

const OabStandalone = StandaloneComponent;
const defineCustomElement = defineCustomElement$1;

export { OabStandalone, defineCustomElement };

//# sourceMappingURL=oab-standalone.js.map